import { FullscreenDisplay } from './../../components/home/fullscreendisplay'

export tag SideMenu
	prop list
	prop selectedItem

	def mount
		selectedItem = list[0]

	def render
		<self>
			<div.side>
				for item in list
					<a
						.menuitem 
						.highlighted=(selectedItem ? selectedItem.name === item.name : false) 
						@mouseover=(selectedItem = item)
						route-to="/projects/{item.name.toLowerCase().replace(/\s+/g, '')}"
					> item.name
			if selectedItem
				<FullscreenDisplay[pos:absolute zi:1 h:100% w:100% t:0 l:0] ease cover=selectedItem.cover>

	css .side pos:fixed w:150px bgc:#141414 o:0.99 h:100% zi: 2 of:-moz-scrollbars-none -ms-overflow-style:none ofy:scroll
		@!799 w:70px
	css .side::-webkit-scrollbar w:0
	css .menuitem writing-mode:vertical-rl cursor:pointer c:#fff va:middle ta:center margin:4rem auto fs:2.5rem fw:bold d:block td:none
		@!799 fs:1.6rem
		&:hover td:line-through
	css .highlighted td:line-through
